import { apiClient } from './client';
import type { LoginRequest, LoginResponse, UserInfo, VerifyCode } from './types';

export async function getVerifyCode(): Promise<VerifyCode> {
  const res = await apiClient.get<VerifyCode>('/ads-admin/auth/verify-code');
  return res.data;
}

export async function login(req: LoginRequest): Promise<LoginResponse> {
  const res = await apiClient.post<LoginResponse>('/ads-admin/auth/login', req);
  return res.data;
}

export async function logout(): Promise<void> {
  await apiClient.post('/ads-admin/auth/logout');
}

export async function getUserInfo(): Promise<UserInfo> {
  const res = await apiClient.get<UserInfo>('/ads-admin/auth/user-info');
  return res.data;
}
